import { IMenuItemInfo, IOrderDetailMenuInfo } from 'apis/types';
import { useAppSelector } from 'app/hooks';
import { selectMenu, selectTimingInfo } from 'store/slices/mainSlice';
import { attrLang, stripHtml } from 'utils';

interface DishOptionListProps {
  dishOrderState: IOrderDetailMenuInfo;
}

const DishOptionList = ({ dishOrderState }: DishOptionListProps) => {
  const menuList = useAppSelector(selectMenu);
  const timingInfo = useAppSelector(selectTimingInfo);

  const dishCode = dishOrderState.MenuCode;
  const dishInfo = menuList[dishCode];

  const getTimingLabel = (timingCode: string, dishInfo: IMenuItemInfo) => {
    const menuTimingInfo = timingInfo[dishInfo.timing_info_id || ''];

    if (!menuTimingInfo || !timingCode) return null;
    const matchedPattern = menuTimingInfo.serving_pattern?.find((p) => Object.keys(p)[0] === timingCode);
    const timingItem = matchedPattern?.[timingCode];
    return timingItem ? attrLang(timingItem, 'msg') : null;
  };

  return (
    <ul className="option-list">
      {dishOrderState.Timing &&
        (() => {
          const timingLabel = getTimingLabel(dishOrderState.Timing, dishInfo);
          if (!timingLabel) return null;

          return <li key="main-timing">{timingLabel}</li>;
        })()}
      {dishOrderState.MenuInfo?.map((optionItem, index) => {
        const optionItemCode = optionItem.MenuCode;
        const optionItemInfo = menuList[optionItemCode];
        const optionItemName = stripHtml(attrLang(optionItemInfo, 'lang'));
        const optionItemQuantity = parseInt(optionItem.CountInfo.Count);
        const childInfo = optionItem.MenuInfo;
        const optionTimingLabel = optionItem.Timing ? getTimingLabel(optionItem.Timing, optionItemInfo) : null;

        if (optionItemInfo) {
          return (
            <li key={optionItemCode + '-' + index}>
              <span>
                {optionItemName} ({optionItemQuantity})
              </span>

              {optionTimingLabel && (
                <ul style={{ paddingLeft: '6px', margin: 0 }}>
                  <li key={`${optionItemCode}-timing`}>{optionTimingLabel}</li>
                </ul>
              )}

              {childInfo && (
                <ul style={{ paddingLeft: '6px' }}>
                  {childInfo.map((childItem, idx) => {
                    const childItemCode = childItem.MenuCode;
                    const childItemMenuInfo = menuList[childItemCode];
                    const childItemName = stripHtml(attrLang(childItemMenuInfo, 'lang'));
                    const childItemQuantity = parseInt(childItem.CountInfo.Count);
                    const childTimingLabel = childItem.Timing ? getTimingLabel(childItem.Timing, optionItemInfo) : null;

                    return (
                      <li key={`${childItemCode}-${idx}`}>
                        <span>
                          {childItemName} ({childItemQuantity})
                        </span>
                        {childTimingLabel && (
                          <ul style={{ paddingLeft: '6px' }}>
                            <li>{childTimingLabel}</li>
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        }
      })}
    </ul>
  );
};

export default DishOptionList;
